import script from "./SocialShare.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialShare.vue?vue&type=script&setup=true&lang=js"

import "./SocialShare.vue?vue&type=style&index=0&id=0b6d0e52&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6d0e52"]])

export default __exports__